import React from "react";
import styled from "styled-components";

const FooterStyles = styled.footer`
  width: 100%;
  text-align: center;
  h1 {
  }
`;

function Footer() {
  return (
    <FooterStyles>
      <p>
        Made by <a href="https://www.eyecandycode.com">EyeCandyCode</a> ©{" "}
        {new Date().getFullYear()}
      </p>
    </FooterStyles>
  );
}

export default Footer;
